import { render, staticRenderFns } from "./electronicbillPFLD.vue?vue&type=template&id=0b86f7e9"
import script from "./electronicbillPFLD.vue?vue&type=script&lang=js"
export * from "./electronicbillPFLD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports